import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/sepa.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')